import type { ReactNode } from 'react';

const escapeRe = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/** Terms worth highlighting from a search query: bare words and quoted
 * phrases; `tag:` / `path:` operators are excluded. */
export function highlightTerms(query: string): string[] {
  const terms: string[] = [];
  const rest = query.replace(/"([^"]*)"/g, (_all, p: string) => {
    if (p.trim()) terms.push(p.trim());
    return ' ';
  });
  for (const tok of rest.split(/\s+/)) {
    if (!tok || /^(tag|path):/i.test(tok)) continue;
    terms.push(tok);
  }
  return terms;
}

/** Wrap case-insensitive occurrences of `terms` in `<mark>`. */
export function markMatches(text: string, terms: string[]): ReactNode {
  const valid = terms.filter(Boolean);
  if (valid.length === 0 || !text) return text;
  let re: RegExp;
  try {
    re = new RegExp(`(${valid.map(escapeRe).join('|')})`, 'gi');
  } catch {
    return text;
  }
  const parts = text.split(re);
  if (parts.length === 1) return text;
  return parts.map((p, i) => (i % 2 === 1 ? <mark key={i}>{p}</mark> : p));
}
